<template>
  <b-row>
    <b-col cols="12">
      <PageTitle title="Panfletos" />
    </b-col>

    <b-col class="mt-3">
      <h4>Tipos</h4>
    </b-col>
    <b-col class="d-flex justify-content-end mr-4 mt-3">
      <b-button 
         @click="$refs.typeFlyerModal.toggleOpen({})"
        variant="success"
      >
        <i class="fas fa-plus mr-1"></i>
        Adicionar Tipo
      </b-button>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-table
        striped
        hover
        responsive
        :fields="tableType.headers"
        :items="tableType.records"
        :busy="loading"
      >
        <template #cell(image)="data">
          <div v-if="data.item.image">
            <img
              :src="getImageAddress(data.item.image)"
              alt="Imagem do panfleto"
              style="width: 60px;"
            />
          </div>
          <div v-else>
            <i class="fas fa-image" style="font-size: 50px;"></i>
          </div>
        </template>
        
        <template #cell(actions)="data">
          <b-button 
            class="ml-2" 
            variant="primary" 
            @click="$refs.typeFlyerModal.toggleOpen({ data: data.item, isUpdate: true })"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button 
            class="ml-2" 
            variant="danger" 
          @click="$refs.deleteTypeFlyerModal.toggleOpen({ name: data.item.name, id: data.item.id })"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </b-col>
    
    <b-col class="mt-5">
      <h4>Panfletos</h4>
    </b-col>
    <b-col class="d-flex justify-content-end mr-4 mt-5">
      <b-button 
        variant="success"
         @click="$refs.flyerModal.toggleOpen({options: tableType.records})"
      >
        <i class="fas fa-plus mr-1"></i>
        Adicionar Panfleto
      </b-button>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-table
        striped
        hover
        responsive
        :fields="tableFlyers.headers"
        :items="tableFlyers.records"
        :busy="loading"
      >
        <template #cell(image)="data">
          <div v-if="data.item.image">
            <img
              :src="getImageAddress(data.item.image)"
              alt="Imagem do panfleto"
              style="width: 60px;"
            />
          </div>
          <div v-else>
            <i class="fas fa-image" style="font-size: 50px;"></i>
          </div>
        </template>

        <template #cell(actions)="data">
          <b-button 
            class="ml-2" 
            variant="primary" 
            @click="$refs.flyerModal.toggleOpen({ data: data.item, options: tableType.records, isUpdate: true })"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button 
            class="ml-2" 
            variant="danger" 
            @click="$refs.deleteFlyerModal.toggleOpen({ data: data.item })"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </b-col>

    <TypeFlyerModal
      ref="typeFlyerModal"
      @saveType="saveType($event)"
      @updateType="editType($event)"
    />

    <DeleteTypeFlyerModal
      ref="deleteTypeFlyerModal"
      @deleteType="deleteTypeFlyer($event)"
    />

    <FlyerModal
      ref="flyerModal"
      @flyerSave="saveFlyer($event)"
      @flayerUpdate="editFlyer($event)"
    />

    <DeleteFlyerModal
      ref="deleteFlyerModal"
      @flyerDelete="deleteFlyer($event)"
    />
  </b-row>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import { mapActions, mapState } from 'vuex';
import UserTypes from '@/enums/UserTypes';
import TypeFlyerModal from '@/components/Flyers/TypeFlyerModal.vue';
import DeleteTypeFlyerModal from '@/components/Flyers/DeleteTypeFlyerModal.vue';
import FlyerModal from '@/components/Flyers/FlyerModal.vue';
import DeleteFlyerModal from '@/components/Flyers/DeleteFlyerModal.vue';

export default {
  name: 'flyers',
  mixins: [makeToast],
  components: {
    PageTitle,
    TypeFlyerModal,
    DeleteTypeFlyerModal,
    FlyerModal,
    DeleteFlyerModal
  },

  data() {
    return {
      loading: false,
      tableType: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'image',
            label: 'Imagem',
            sortable: false,
          },
          {
            key: 'name',
            label: 'Nome',
            sortable: false,
          },
          {
            key: 'link',
            label: 'Link',
            sortable: false,
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
      tableFlyers: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'image',
            label: 'Imagem',
            sortable: false,
          },
          {
            key: 'title',
            label: 'TItulo',
            sortable: false,
          },
          {
            key: 'link',
            label: 'Link',
            sortable: false,
          },
          {
            key: 'type',
            label: 'Tipo',
            sortable: false,
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getTypeFlyers',
      'createTypeFlyers',
      'upateTypeFlyers',
      'deleteTypeFlyers',
      'createFlyers',
      'getDataFlyers',
      'deleteFlyers',
      'updateFlyers'  
    ]),
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    getImageAddress(image) {
      const url = process.env.VUE_APP_FOTOS_AWS + 'panfletos/'; 
      return url + image;
    },
    get() {
      this.tableFlyers.records = [];
      this.tableType.records = [];
      
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.getTypeFlyers(this.userTypeId())
        .then((response) => {
          const data = response.data.data;

          if (!data) return;

          data.forEach(item => {
            this.tableType.records.push({
              id: item.id,
              image: item.image,
              name: item.name,
              link: item.link,
            });

            item.get_flyers.forEach(flyer => {
              this.tableFlyers.records.push({
                id: flyer.id,
                image: flyer.image,
                title: flyer.title,
                link: flyer.link,
                isCover: flyer.is_cover,
                type: item.name,
                typeId: item.id,
              })

              if(flyer.is_cover) {
                this.tableType.records[this.tableType.records.length - 1].image = flyer.image;
              }
            });
          });
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    saveType(event) {
     const dataSend = { 
        construp_user_id: this.userTypeId(),
        name: event.name,
        link: event.link
      }

      this.$store.dispatch('startLoader');
      this.loading = true;
      this.createTypeFlyers(dataSend)
        .then((response) => {
          const data = response.data.data;

          if (!data) return;
          this.makeToast('Sucesso!', 'Criado com sucesso', 'success');
          this.get();
        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
          this.makeToast('Oopss!', 'Houve um erro ao salvar', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          
          this.loading = false;
        });
    },
    saveFlyer(event) {
      const dataSend = { 
        type_flyers_id: event.type_flyers_id,
        title: event.name,
        link: event.link,
        is_cover: event.is_cover,
        image: event.image
      }

      this.$store.dispatch('startLoader');
      this.loading = true;

      this.createFlyers(dataSend)
        .then((response) => {
          const data = response.data.data;

          if (!data) return;
          this.makeToast('Sucesso!', 'Salvo com sucesso', 'success');
          this.get();
        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
          this.makeToast('Oopss!', 'Houve um erro ao salvar', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    editType(event) {
      const dataSend = { 
        id: event.id,
        construp_user_id: this.userTypeId(),
        name: event.name,
        link: event.link
      }
      
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.upateTypeFlyers(dataSend)
        .then((response) => {
          const data = response.data.data;

          if (!data) return;
          this.makeToast('Sucesso!', 'Atualizado com sucesso', 'success');
          this.get();
        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
          this.makeToast('Oopss!', 'Houve um erro ao atualizar', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    editFlyer(event) {
      const dataSend = { 
        id: event.id,
        type_flyers_id: event.type_flyers_id,
        title: event.name,
        link: event.link,
        is_cover: event.is_cover,
        image: event.image
      }

      this.$store.dispatch('startLoader');
      this.loading = true;

      this.updateFlyers(dataSend)
        .then((response) => {
          const data = response.data.data;

          if (!data) return;
          this.makeToast('Sucesso!', 'Atualizado com sucesso', 'success');
          this.get();
        })
        .catch((error) => {
           this.$store.dispatch('endLoader');
          this.makeToast('Oopss!', 'Houve um erro ao atualizar', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    deleteTypeFlyer(id) {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.deleteTypeFlyers(id)
        .then((response) => {
          const data = response.data.data;

          if (!data) return;
          this.makeToast('Sucesso!', 'Deletado com sucesso', 'success');
          this.get();
        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
          this.makeToast('Oopss!', 'Houve um erro ao deletar', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    deleteFlyer(event) {
      const id = event;
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.deleteFlyers(id)
        .then((response) => {
          const data = response.data.data;

          if (!data) return;
          this.makeToast('Sucesso!', 'Deletado com sucesso', 'success');
          this.get();
        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
          this.makeToast('Oopss!', 'Houve um erro ao apagar', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    }
  },
};
</script>
